<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12 class="pt-10">
        <div>
          <h1>You've Successfully Subscribed!</h1>
          <p
            class="mt-8"
          >Thank you for subscribing to The Outdoor Wire Digital Network's newsletter(s).</p>
          <!-- <ul class="mx-4">
            <li>Find the confirmation email in your inbox</li>
            <li>Click on the confirmation link in the email body</li>
            <li>Enjoy reading your newsletter(s)!</li>
          </ul>-->
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "pendingConfirmation",
  computed: {
    code() {
      return this.$route.query.code;
    },
  },
  async created() {
    try {
      await axios({
        method: "get",
        url: `/api/confirm/${this.code}`,
      });
    } catch (e) {
      // eslint-disable-next-line
      console.error(e);
    }
  },
};
</script>
